import { useState } from "react";

// // Import Context
// import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";

// // Hooks
// import { useDeleteStaffOrder } from "../../hooks/useDeleteStaffOrder";
// import { useCheckAPI } from "../../hooks/useCheckAPI";

// // Components
import { OrderItemsSummaryTable } from "../../components/OrderItemsSummaryTable";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
// import IconButton from "@mui/material/IconButton";
// import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Chip from "@mui/material/Chip";

export const ViewStaffItemsDialog = ({
  items,
  itemsCount,
  person,
  order,
  orderType = "draft",
}) => {
  // const { mutate, isSuccess, data } = useDeleteStaffOrder();
  const [open, setOpen] = useState(false);
  // const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <Chip label={itemsCount} variant="outlined" onClick={handleOpen} />
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
        aria-labelledby="staff-items-summary-dialog"
      >
        <DialogTitle id="staff-items-summary-dialog-title">
          Summary for {person.name}
        </DialogTitle>
        <DialogContent>
          <OrderItemsSummaryTable
            items={items}
            order={order}
            person={person}
            orderType={orderType}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          {/* <Button onClick={handleDelete} autoFocus>
            Remove
          </Button> */}
        </DialogActions>
      </Dialog>
    </Box>
  );
};
